import styled from "styled-components"

export const HeaderWrapp = styled.div`
  .header {
    background: rgba(250, 249, 246, 0.92);
    border-bottom: 1px solid #e7e2d8;
    backdrop-filter: blur(12px);
    width: 100%;
    position: fixed;
    top: 0;
    z-index: 10;

    .header-content {
      height: 64px;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .logo {
        width: 126px;
        height: auto;
        display: block;
      }

      .list {
        display: flex;
        align-items: center;
        font-size: 14px;
        font-weight: 600;
        color: #28342f;

        li {
          margin-left: 28px;
        }

        a {
          color: #28342f;
          transition: color 0.2s ease;

          &:hover {
            color: #5f7967;
          }
        }

        .logo {
          margin: 0 80px;
        }
      }

      .hamburger img {
          width: 26px; 
        }
    }

    .logo-mobile {
      height: 64px;
      display: flex;
      align-items: center;
      margin-left: 20px;

      .logo {
        width: 120px;
        height: auto;
      }
    }
  }
  

  @media (max-width: 762px) {
    .display-desktop {
      display: none;
    }
  }

  @media (min-width: 762px) {
    .display-mobile {
      display: none;
    }
  }
`
